module.exports = "<div class=\"alert alert-warning missing-working-days\" *ngIf=\"data.length > 0\">\r\n    <div class=\"alert-title ng-binding\">Timecards are waiting for your approval</div>\r\n    <div *ngFor=\"let timecard of data\">\r\n        <a (click)=\"goToTimeCard(timecard)\" class=\"clickable\">{{timecard.sequenceId}}  {{timecard.startDate}} - {{timecard.endDate}}</a>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/notifications/unapproved-timecards/unapproved-timecards.component.html
// module id = 498
// module chunks = 0